const situations = [
  'руководитель понял принцип делегирования, но продолжает забирать задачи обратно;',
  'знает правила обратной связи, но избегает сложных разговоров;',
  'изучил SMART, но продолжает ставить задачи в формате «сделай побыстрее»;',
  'знает модели мотивации, но не использует их в ежедневной работе;',
  'понимает необходимость развития сотрудников, но постоянно работает только с сильными исполнителями.',
];

export default function WhyTrainingNotEnough() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему знания сами по себе не делают руководителя сильнее
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Однократный тренинг может дать инструменты и изменить понимание проблемы, но устойчивое изменение управленческого поведения требует практики. Вот типичные ситуации:
        </p>

        <div className="grid sm:grid-cols-1 gap-3 max-w-4xl mx-auto mb-12">
          {situations.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Развитие управленческих компетенций — это процесс формирования нового управленческого поведения, а не передача набора знаний.
          </p>
        </div>
      </div>
    </section>
  );
}